function RefineTaskSortController($scope, refineStateService) {
  $scope.filter = $scope.filterSet.getFilter('taskSort');

  $scope.sort = $scope.filter.value;

  $scope.update = () => {
    $scope.filter.changeValue($scope.sort);
  };

  // Get, then watch the state (expanded or !) of this search refiner
  $scope.expanded = refineStateService.isExpanded('taskSort');
  $scope.expanded = true;
  $scope.$watch('expanded', refineStateService.curriedSet('taskSort'));
}

const controllerArray = [
  '$scope',
  'refineStateService',
  RefineTaskSortController
];

export default function (ngModule) {
  ngModule.controller('RefineTaskSortController', controllerArray);
}
